import React from 'react';
import styled from 'styled-components';
import useTranslation from 'next-translate/useTranslation';
import { TextRegular14 } from '../../VuexyDesign/atoms/Text';
import Flex from '../common/Flex';
import { Button } from '../../VuexyDesign/atoms/_index';
import Link from '../common/Link';
import { useIsLoggedIn } from '../../api';
import { ReleaseYourMusicBanner } from '../MyTracks/ReleaseYourMusicBanner';

function JoinOurDemoCard() {
  const userLoggedIn = useIsLoggedIn();
  const { t } = useTranslation('musicKnowledgeHub');
  return (
    <SideBannerWrapper>
      {userLoggedIn ? (
        <ReleaseYourMusicBanner isMobileView />
      ) : (
        <JoinOurDemoCardContainer className="px-2 py-1">
          <Flex mb="0.5rem" flexDirection="column" justifyContent="center">
            <div className="join-demo-title-width">
              <span className="join-demo-title ">
                {t('musicKnowledgeHub:joinOurDemoCommunity')}
              </span>
            </div>
            <div className="join-demo-description mt-1">
              <TextRegular14>
                {t('musicKnowledgeHub:uploadDemos')}
              </TextRegular14>
            </div>

            <div className="d-flex justify-content-start flex-column mt-1 w-75">
              <Link href="/register">
                <Button color="light">
                  {t('musicKnowledgeHub:createAnAccount') as string}
                </Button>
              </Link>
            </div>
          </Flex>
        </JoinOurDemoCardContainer>
      )}
    </SideBannerWrapper>
  );
}

const SideBannerWrapper = styled.div`
  padding: 0.8rem 0.8rem 0rem 0.8rem;
`;
const JoinOurDemoCardContainer = styled.div`
  background-color: #f71454;
  color: #f5f8fe;
  margin-bottom: 1rem;
  border-radius: 6px;
  .join-demo-title-width {
    width: 80%;
  }
  .join-demo-title {
    font-weight: 700;
    font-size: 24px;
    line-height: 31px;
  }
  .join-demo-description {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
  }
  .margin-created-date {
    margin-top: 0.15rem;
  }
  .style-created-date {
    font-weight: 400;
    font-size: 12px;
    color: #000000;
    opacity: 0.5;
  }
`;

export default JoinOurDemoCard;
